import { getVideoContext, getVideoRelated } from '../redux/actions/video'
import { webTdk, mixUrl } from 'multiPublic/index'

export default async (context, options = {}) => {
    const { match, store, req } = context
    const { includeRelated = true } = options
    const videoId = match.params.id
    const publishTime = match.params.time
    let tdk = {
        title: '',
        keywords: '',
        description: ''
    }

    async function getDetailData () {
        const detail = await store.dispatch(getVideoContext({
            id: videoId,
            publishTime,
            req
        }))
        if (detail.code !== 1) throw Error(detail.msg)

        const current = detail.obj.current
        tdk = {
            title: `${current.title}_${current.nickName}_火星财经`,
            keywords: current.tags || webTdk.keywords,
            description: `${current.content}来源于火星财经专栏作家${current.nickName}`
        }
    }

    const requests = [getDetailData()]
    if (includeRelated) {
        requests.push(store.dispatch(getVideoRelated({ id: videoId, limit: 4, req })))
    }
    await Promise.all(requests)

    return {
        clientLink: mixUrl.m(match.url),
        ...tdk
    }
}
